import { Box, Checkbox, Typography } from '@mui/material';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

import { UserData } from '@codefluegel/wowis-rest-typescript-client';
import useMedia from '../../hooks/useMedia';
import CardContainer from '../../components/cards/CardContainer';

interface Props {
  user: UserData | undefined;
  onDataChanged: (dataChanged: boolean) => void;
}

export interface GetDigitalSignatureHandle {
  getDigitalSignatureState: () => boolean;
}

const DigitalSignature = forwardRef<GetDigitalSignatureHandle, Props>(
  (props, ref) => {
    const { user, onDataChanged } = props;
    const isMobile = useMedia('md');

    const title = 'Digitale Unterschrift';

    const [digitalSignatureFlag, setDigitalSignatureFlag] = useState(
      user?.digitalSignature || false,
    );

    useImperativeHandle(ref, () => ({
      getDigitalSignatureState: () => digitalSignatureFlag,
    }));

    useEffect(() => {
      setDigitalSignatureFlag(user?.digitalSignature || false);
    }, [user]);

    return (
      <Box width={1}>
        <CardContainer
          title={title}
          customStyle={{
            sx: {
              margin: 0,
              marginBottom: 3,
            },
          }}
          iconOn
          iconName={title}
        >
          <Box
            sx={{
              width: 1,
              minHeight: isMobile ? 1 : '100px',
              marginBottom: isMobile ? 4 : 0,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 10,
                paddingRight: 10,
                paddingBottom: isMobile ? 0 : 2,
              }}
              flexDirection="row"
            >
              <Checkbox
                sx={{
                  height: 50,
                  marginRight: 1,
                }}
                checked={digitalSignatureFlag}
                color="primary"
                onChange={e => {
                  setDigitalSignatureFlag(e.target.checked);
                  onDataChanged(true);
                }}
              />
              <Typography variant="body2" color="secondary">
                Digitale Unterschrift verwenden
              </Typography>
            </Box>
          </Box>
        </CardContainer>
      </Box>
    );
  },
);

export default DigitalSignature;
